import { render, staticRenderFns } from "./NewEmoji.vue?vue&type=template&id=36b8b05e&"
import script from "./NewEmoji.vue?vue&type=script&lang=js&"
export * from "./NewEmoji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports